var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.formattedValue},on:{"click":_vm.preventValueChange}}),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }